/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint @typescript-eslint/no-var-requires: "off" */
import axios from 'axios'
import moment from 'moment'
import { formatToInputDateWDH } from 'utils/Common/date-utils'
import WasteRegisterEntity from 'utils/__interfaces/WasteRegister/WasteRegisterEntity'

const XlsxTemplate = require('xlsx-template')

const INPUT_DATE_FORMAT_YEAR_MONTH = 'YYYY-MM'

export async function generateWasteRegister(
  startDate: Date,
  endDate: Date,
  listofIds: string[],
  sendRegisterByEmail = false
): Promise<any> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/registre_dechets`

  const expeditionDateBefore = formatToInputDateWDH(
    endDate,
    null,
    INPUT_DATE_FORMAT_YEAR_MONTH
  )
  const expeditionDateAfter = formatToInputDateWDH(
    startDate,
    null,
    INPUT_DATE_FORMAT_YEAR_MONTH
  )

  try {
    const resp = await axios({
      method: 'POST',
      url,
      data: {
        anneeMois: {
          before: expeditionDateBefore,
          after: expeditionDateAfter,
        },
        fkContrats: listofIds,
        sendRegisterByEmail,
      },
    })
    return resp.data
  } catch (err) {
    throw new Error(
      `Erreur lors de l'obtention du registre des déchet avec l'url: ${url}`
    )
  }
}

export async function downloadWasteRegister(
  filename: string
): Promise<{ status: number; data: string | null }> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/registre_dechets/${filename}/file`

  try {
    const resp = await axios.get(url)
    return { status: resp.status, data: resp.data.file_base64 }
  } catch (err) {
    return { status: err.response.status, data: null }
  }
}

export function GenerateExcel(
  data: WasteRegisterEntity[],
  startDate: Date,
  endDate: Date
) {
  fetch('/resources/registreDechetsV2.xlsx').then((response) => {
    response.arrayBuffer().then((buffer) => {
      const template = new XlsxTemplate(buffer)
      const values = {
        extractDate: moment(new Date()).format('DD/MM/YYYY'),
        StartDate: moment(startDate).startOf('month').format('DD/MM/YYYY'),
        EndDate: moment(endDate).endOf('month').format('DD/MM/YYYY'),
        registre: data,
      }
      template.substitute(1, values)
      const result = template.generate({ type: 'arraybuffer' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([result]))
      const day = moment(new Date()).format('YYYY_MM_DD')
      const filename = `Registre_dechets_${day}.xlsx`
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    })
  })
}
